import { render, staticRenderFns } from "./ComponentAPI.vue?vue&type=template&id=03ccf6b8&scoped=true&"
import script from "./ComponentAPI.vue?vue&type=script&lang=js&"
export * from "./ComponentAPI.vue?vue&type=script&lang=js&"
import style0 from "./ComponentAPI.vue?vue&type=style&index=0&id=03ccf6b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ccf6b8",
  null
  
)

export default component.exports